import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatDividerModule } from '@angular/material/divider'
import { NgxMaskDirective } from 'ngx-mask'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { EmployeeRoleService } from '../../../core/services/employee/employee-role/employee-role.service'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { emailValidator } from '../../../shared/utils/email_validator'
import moment from 'moment/moment'
import { cpfValidator } from '../../../shared/utils/cpf_validator'
import { ContactClientEditComponent } from '../../contact/contact-client-edit/contact-client-edit.component'

@Component({
  selector: 'employee-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatOption,
    MatSelect,
    MatDividerModule,
    NgxMaskDirective,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    ContactClientEditComponent,
  ],
  templateUrl: './employee-edit.component.html',
  styleUrl: './employee-edit.component.scss',
  providers: [
    ViaCepService,
    EmployeeStatusService,
    EmployeeService,
    EmployeeRoleService,
    AddressTypeService,
  ],
  standalone: true,
})
export class EmployeeEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private viaCepService: ViaCepService,
    private employeeStatusService: EmployeeStatusService,
    private employeeService: EmployeeService,
    private addressTypeService: AddressTypeService,
    private employeeRoleService: EmployeeRoleService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<EmployeeEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = this.data.item
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const currentDay = today.getDate()
    this.maxDate = new Date(currentYear - 18, currentMonth, currentDay)
  }

  @Output() responseEdit = new EventEmitter()
  @ViewChild('birth') datepickerBirth: MatDatepicker<any> | undefined
  @ViewChild('hiring') datepickerHiring: MatDatepicker<any> | undefined

  formEmployee: FormGroup = new FormGroup({})
  maxDate!: Date

  loading: boolean = false
  loadingScreen: boolean = true

  item: any = {}

  listAddressType: any[] = []
  listStatusEmployee: any[] = []
  listRoleEmployee: any[] = []

  contactList: any[] = []

  ngOnInit(): void {
    this.getAddressType()
    this.getRoleEmployee()
    this.getStatusEmployee()
    this.createForm()
  }

  close() {
    this.dialogRef.close()
  }

  getAddressType() {
    this.addressTypeService.listAddressType().subscribe({
      next: (response: any) => {
        let list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listAddressType = list
      },
      error: (err: any) => {},
      complete: () => {},
    })
  }

  getRoleEmployee() {
    this.employeeRoleService.listEmployeeRole().subscribe({
      next: (response: any) => {
        let list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listRoleEmployee = list
      },
      error: (err: any) => {},
      complete: () => {},
    })
  }

  getStatusEmployee() {
    this.employeeStatusService.listEmployeeStatus().subscribe({
      next: (response: any) => {
        let list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listStatusEmployee = list
      },
      error: (err: any) => {},
      complete: () => {},
    })
  }

  createModel() {
    return {
      funcionario: {
        id: this.item.id,
        funcionarioFuncaoId: this.formEmployee.get('roleEmployee')?.value,
        statusId: this.formEmployee.get('statusEmployee')?.value,
        nome: this.formEmployee.get('name')?.value,
        matricula: this.formEmployee.get('registration')?.value,
        dataNascimento:
          this.formEmployee.get('birth')?.value != ''
            ? moment(this.formEmployee.get('birth')?.value).format('DD/MM/YYYY')
            : '',
        pessoaId: this.item.pessoaId,
        // email: this.formEmployee.get('email')?.value,
        // cpf: this.formEmployee.get('cpf')?.value,
        // dataContratacao: moment(this.formEmployee.get('hiring')?.value).format(
        //   'DD/MM/YYYY',
        // ),
        email: this.item.email,
        cpf: this.item.cpf,
        dataContratacao:
          this.item.dataContratacao != '' ? this.item.dataContratacao : '',
        isUsuario: 'S',
      },
      endereco: {
        id: this.item.enderecoId,
        tipo_endereco_id: this.formEmployee.get('addressType')?.value,
        cep: this.formEmployee.get('postalCode')?.value,
        logradouro: this.formEmployee.get('street')?.value,
        bairro: this.formEmployee.get('neighborhood')?.value,
        numero: this.formEmployee.get('number')?.value,
        complemento: this.formEmployee.get('complement')?.value,
        cidade: this.formEmployee.get('city')?.value,
        estado: this.formEmployee.get('state')?.value,
        pais: this.formEmployee.get('country')?.value,
        latitude: '',
        longitude: '',
        ativo: 'S',
      },
    }
  }

  createForm(): void {
    this.formEmployee = this.formBuilder.group({
      // Employee fields
      roleEmployee: ['', [Validators.required]],
      statusEmployee: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, emailValidator()]],
      cpf: ['', [Validators.required, cpfValidator()]],
      birth: ['', [Validators.required]],
      registration: [''],
      hiring: [''],
      // Adress fields
      addressType: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      street: ['', [Validators.required]],
      number: ['', [Validators.required]],
      neighborhood: ['', [Validators.required]],
      complement: [''],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      country: ['', [Validators.required]],
    })
    this.formEmployee.get('email')?.disable()
    this.formEmployee.get('cpf')?.disable()
    try {
      this.fillForm()
    } catch (error) {
      console.error(error)
    } finally {
      this.loadingScreen = false
    }
  }

  fillForm() {
    this.formEmployee
      .get('roleEmployee')
      ?.setValue(this.item.funcionarioFuncaoId)
    this.formEmployee.get('statusEmployee')?.setValue(this.item.statusId)
    this.formEmployee.get('name')?.setValue(this.item.nome)
    this.formEmployee.get('email')?.setValue(this.item.email)
    this.formEmployee.get('cpf')?.setValue(this.item.cpf)
    this.formEmployee.get('registration')?.setValue(this.item.matricula)
    this.formEmployee
      .get('birth')
      ?.setValue(moment(this.item.dataNascimento, 'DD/MM/YYYY').toDate())
    this.formEmployee
      .get('hiring')
      ?.setValue(moment(this.item.dataContratacao, 'DD/MM/YYYY').toDate())
    this.formEmployee.get('addressType')?.setValue(this.item.tipoEnderecoId)
    this.formEmployee.get('postalCode')?.setValue(this.item.cep)
    this.formEmployee.get('street')?.setValue(this.item.logradouro)
    this.formEmployee.get('number')?.setValue(this.item.numero)
    this.formEmployee.get('neighborhood')?.setValue(this.item.bairro)
    this.formEmployee.get('complement')?.setValue(this.item.complemento)
    this.formEmployee.get('city')?.setValue(this.item.cidade)
    this.formEmployee.get('state')?.setValue(this.item.estado)
    this.formEmployee.get('country')?.setValue(this.item.pais)
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.formEmployee.get('street')?.setValue('')
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('complement')?.setValue('')
      this.formEmployee.get('neighborhood')?.setValue('')
      this.formEmployee.get('city')?.setValue('')
      this.formEmployee.get('state')?.setValue('')
      this.formEmployee.get('country')?.setValue('')
    } else {
      this.formEmployee.get('street')?.setValue(element.logradouro)
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('complement')?.setValue(element.complemento)
      this.formEmployee.get('neighborhood')?.setValue(element.bairro)
      this.formEmployee.get('city')?.setValue(element.localidade)
      this.formEmployee.get('state')?.setValue(element.estado)
      this.formEmployee.get('country')?.setValue('Brasil')
    }
  }

  getAddressByPostalCode() {
    let postalCode = this.formEmployee.get('postalCode')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    }
  }

  getList(list: any[]) {
    this.contactList = list
  }

  createEmployee() {
    this.loading = true
    this.employeeService.editEmployee(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        // this.formIndividual.reset()
        // this.formFinancial.reset()
      },
    })
  }

  openDatepicker(datePicker: 'hiring' | 'birth') {
    if (this.datepickerBirth && datePicker == 'birth') {
      this.datepickerBirth.open()
    }
    if (this.datepickerHiring && datePicker == 'hiring') {
      this.datepickerHiring.open()
    }
  }
}
